<div class="material-datatables">
  <table
    id="customerstables"
    class="table table-striped table-no-bordered table-hover"
    cellspacing="0"
    width="100%"
    style="width: 100%"
  >
    <thead>
      <tr>
        <th>ID</th>
        <th>Rep name</th>
        <th>Company Name</th>
        <th>Name</th>
        <th>Alias</th>
        <th>Country</th>
        <th>email</th>
        <th>Date</th>
        <th style="text-align: center">Average Rating</th>
        <th>Status</th>
        <th class="disabled-sorting text-right">Actions</th>
      </tr>
    </thead>

    <tbody>
      <tr
        id="itemweight{{ row[0] }}"
        *ngFor="let row of dataTable.dataRows; let i = index"
      >
        <td>{{ row[0] }}</td>
        <td>{{ row[1] }}</td>
        <td>{{ row[2] }}</td>
        <td>{{ row[3] }}</td>
        <td>{{ row[9] }}</td>
        <td>{{ row[4] }}</td>
        <td>
          <a target="_blank" [href]="'mailto:' + row[5]">
            {{ row[5] }}
          </a>
        </td>
        <td>{{ row[8] | date : "MM/dd/yyyy" }}</td>
        <td style="text-align: center">
          <!-- {{row[6]}}  -->
          <a class="rank btn-just-icon">
            <i
              class="fa"
              [ngClass]="{ 'fa-star': row[6] >= 1, 'fa-star-o': row[6] < 1 }"
              aria-hidden="true"
            ></i>
          </a>
          <a class="rank btn-just-icon">
            <i
              class="fa"
              [ngClass]="{ 'fa-star': row[6] >= 2, 'fa-star-o': row[6] < 2 }"
              aria-hidden="true"
            ></i>
          </a>
          <a class="rank btn-just-icon">
            <i
              class="fa"
              [ngClass]="{ 'fa-star': row[6] >= 3, 'fa-star-o': row[6] < 3 }"
              aria-hidden="true"
            ></i>
          </a>
          <a class="rank btn-just-icon">
            <i
              class="fa"
              [ngClass]="{ 'fa-star': row[6] >= 4, 'fa-star-o': row[6] < 4 }"
              aria-hidden="true"
            ></i>
          </a>
          <a class="rank btn-just-icon">
            <i
              class="fa"
              [ngClass]="{ 'fa-star': row[6] >= 5, 'fa-star-o': row[6] < 5 }"
              aria-hidden="true"
            ></i>
          </a>
        </td>
        <td class="emitir" id="delete-{{ row[0] }}">
          <button
            class="btn {{
              row[7] == '1' ? 'btn-success' : 'btn-danger'
            }} btn-sm"
            
          >
            <i class="material-icons">power_settings_new</i> &nbsp;
            <span>{{ row[7] == "1" ? "Active" : "Inactive" }}</span>
          </button>
        </td>
        <td class="text-right">
          <a class="btn btn-link btn-info btn-just-icon"
            ><i class="material-icons emitir" id="show-{{ row[0] }}"
              >remove_red_eye</i
            ></a
          >
          <a
            *ngIf="row[10] !== null"
            class="btn btn-link btn-warning btn-just-icon"
            ><i class="material-icons emitir" id="chat-{{ row[0] }}"
              >chat_bubble</i
            ></a
          >
          <!-- <a class="btn btn-link btn-dark btn-just-icon" (click)="saveEmit('print',row[0], row)"><i class="material-icons">local_printshop</i></a> -->
          <!-- <a (click)="saveEmit('delete',row[0], row)" class="btn btn-link btn-danger btn-just-icon"><i class="material-icons">close</i></a> -->
        </td>
      </tr>
    </tbody>
  </table>
</div>
